import React from "react";

import { useTranslation } from "react-i18next";
import { useLanguage } from "../../context/LanguageContext";
import { getLabel } from "../../utils/languageUtils";

import ProfileCard from "./ProfileCard";
import ProfileRow from "./ProfileRow";
import MultiSelectField from "../../common/profile/MultiSelectField";

export default function FarmerInformationCard({

    data,
    errors,
    activityTypes,
    onAddActivityType,
    onRemoveActivityType,
    handleChange

}) {

    const { t } = useTranslation();

    const { language } = useLanguage();

    return (

        <ProfileCard
            title={t("monProfile.farmerInformation")}
            icon="bi-tree-fill"
        >

            {/* =====================================================
                TYPE D'ACTIVITÉ
            ====================================================== */}

            <ProfileRow
                label={t("menu.activityProf")}
                icon="bi-person-badge"
                type="select"
                name="natureActivityType"
                value={data.natureActivityType}
                onChange={handleChange}
                error={errors.natureActivityType}
                options={[
                    {
                        id: "C",
                        libelle: t(
                            "monProfile.activityTypes.agriculture"
                        )
                    },
                    {
                        id: "L",
                        libelle: t(
                            "monProfile.activityTypes.livestock"
                        )
                    },
                    {
                        id: "M",
                        libelle: t(
                            "monProfile.activityTypes.mixed"
                        )
                    }
                ]}

                optionValue="id"

                optionLabel={(item) =>
                    item.libelle
                }

            />

            {/* =====================================================
                ACTIVITÉS AGRICOLES
            ====================================================== */}

            <MultiSelectField
                key={`activity-${data.natureActivityType}`}
                label={t( "monProfile.agriculturalActivities"  )}
                options={activityTypes}
                value={ data.activityTypes || [] }
                optionValue="id"
                optionLabel={(a) => getLabel( a, "activityType", language  )}
                onAdd={onAddActivityType}
                onRemove={onRemoveActivityType}
                isDisabled={  !data.natureActivityType
                }

            />

            {/* =====================================================
                SYSTÈME D'IRRIGATION
            ====================================================== */}

            <ProfileRow
                type="select"
                label={t(    "monProfile.irrigationSystem" )}
                icon="bi-droplet-fill"
                name="irrigationSystem"
                value={data.irrigationSystem}
                onChange={handleChange}
                error={errors.irrigationSystem}
                options={[{ 
                    id: true, 
                    libelle: t("common.yes" ) }, { id: false,
                        libelle: t(
                            "common.no"
                        )
                    }
                ]}

                optionValue="id"

                optionLabel={(item) =>
                    item.libelle
                }

            />

            {/* =====================================================
                ASSURANCE AGRICOLE
            ====================================================== */}

            <ProfileRow

                type="select"

                label={t(
                    "monProfile.agriculturalInsurance"
                )}

                icon="bi-shield-check"

                name="insuranceStatus"

                value={data.insuranceStatus}

                onChange={handleChange}

                error={errors.insuranceStatus}

                options={[
                    {
                        id: true,
                        libelle: t(
                            "common.yes"
                        )
                    },
                    {
                        id: false,
                        libelle: t(
                            "common.no"
                        )
                    }
                ]}

                optionValue="id"

                optionLabel={(item) =>
                    item.libelle
                }

            />

            {/* =====================================================
                ANNÉES D'EXPÉRIENCE
            ====================================================== */}

            <ProfileRow

                type="number"

                label={t(
                    "monProfile.yearsOfExperience"
                )}

                icon="bi-award"

                name="nbAnneesExperience"

                value={
                    data.nbAnneesExperience
                }

                onChange={handleChange}

                error={
                    errors.nbAnneesExperience
                }

            />

        </ProfileCard>

    );

}